<div class="row">
	<div class="col-lg-12">
		<div class="card">
			<div class="card-header align-items-center d-flex">
				<h4 class="card-title mb-0 flex-grow-1">FYI Dispos</h4>
			</div>
			<!-- end card header -->
			<div class="card-body">
				<div class="row">
					<div class="col-12">
						<app-table
							[tableName]="'FYI Dispos'"
							[tableConfig]="tableConfig"
							[buttons]="buttons"
							[theads]="theads"
							[data]="dispos"
							[count]="true"
						>
						</app-table>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
